export const isOdd = (num: number) => { 
    return num % 2;
}